module.exports = __webpack_public_path__ + "static/media/ZH.97e019e1.png";